module.exports = __webpack_public_path__ + "media/images/technology/equipment-icon-a87ce16718566b3982bb281ae0f922f1.png";